import { Component, Injector, OnDestroy, OnInit, Input } from '@angular/core';
import { ThemesLayoutBaseComponent } from '../themes/themes-layout-base.component';
import { AbpSessionService } from 'abp-ng2-module';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    standalone: false,
    selector: 'chat-toggle-button',
    templateUrl: './chat-toggle-button.component.html'
})
export class ChatToggleButtonComponent extends ThemesLayoutBaseComponent implements OnInit, OnDestroy {

    unreadChatMessageCount = 0;
    chatConnected = false;
    isHost = false;
    @Input() isDropup = false;
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean btn-md mr-1';
    private readonly unreadMessageCountChangedHandler = (messageCount) => {
        this.unreadChatMessageCount = messageCount;
    };
    private readonly chatConnectedHandler = () => {
        this.chatConnected = true;
    };

    public constructor(
        injector: Injector,
        private _abpSessionService: AbpSessionService,
        _dateTimeService: DateTimeService
    ) {
        super(injector, _dateTimeService);
    }

    ngOnInit(): void {
        this.registerToEvents();
        this.isHost = !this._abpSessionService.tenantId;
    }

    registerToEvents() {
        abp.event.on('app.chat.unreadMessageCountChanged', this.unreadMessageCountChangedHandler);

        abp.event.on('app.chat.connected', this.chatConnectedHandler);
    }

    ngOnDestroy(): void {
        abp.event.off('app.chat.unreadMessageCountChanged', this.unreadMessageCountChangedHandler);
        abp.event.off('app.chat.connected', this.chatConnectedHandler);
    }
}
